import Button from '@components/buttons/button'

import styles from './close-button.module.scss'

type CloseButtonProps = {
  onClick: () => void
  id?: string
  className?: string
  variant?: 'circle' | 'square'
}

const CloseButton = ({ onClick, id, className, variant = 'circle' }: CloseButtonProps): JSX.Element => (
  <Button noDefaultStyle className={`${className || ''} ${styles[variant]} ${styles.base}`} onClick={onClick} id={id}>
    &#10005;
  </Button>
)

export default CloseButton
